module.exports = __webpack_public_path__ + "img/csv-icon.88c95a2f.png";